"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.promise.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.is.js");

var _react = require("react");

var _tools = require("../../tools");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var cache = {};

var useService = function useService(model, deps, options) {
  var _ref = deps || [],
      _ref2 = _slicedToArray(_ref, 1),
      service = _ref2[0];

  var firstRenderFlagRef = (0, _react.useRef)(true);
  var serviceCacheRef = (0, _react.useRef)(service);

  var _ref3 = options || {},
      suspenseKey = _ref3.suspenseKey,
      cacheFlag = _ref3.cache,
      control = _ref3.control;

  var methodName = cacheFlag ? 'cache' : 'race';

  if (suspenseKey) {
    if (cache[suspenseKey]) {
      var promise = cache[suspenseKey];

      if (promise.success) {
        model.silent(promise.data);
        firstRenderFlagRef.current = false;
        delete cache[suspenseKey];
      } else if (promise.success === false) {
        firstRenderFlagRef.current = false;
        delete cache[suspenseKey];
      } else {
        throw promise;
      }
    }
  }

  if (firstRenderFlagRef.current && typeof service === 'function' && !(0, _tools.isModel)(control)) {
    firstRenderFlagRef.current = false;
    var result = service(model());

    if ((0, _tools.isAsync)(result)) {
      if (suspenseKey) {
        var p = model[methodName](function () {
          return result;
        }).then(function (data) {
          p.success = true;
          p.data = data;
        }).catch(function (err) {
          p.success = false;
          return Promise.reject(err);
        });
        cache[suspenseKey] = p;
        throw p;
      }

      model[methodName](function () {
        return result;
      });
    } else {
      model(result);
    }
  }

  if (!Object.is(serviceCacheRef.current, service)) {
    serviceCacheRef.current = service;

    if (typeof service === 'function') {
      var _result = service(model());

      if ((0, _tools.isAsync)(_result)) {
        model[methodName](function () {
          return _result;
        });
      } else {
        model(_result);
      }
    }
  }
};

var _default = useService;
exports.default = _default;